export const filterOptions = [
    'user_asset_class',
    'user_industry',
    'contract_currency',
    'user_geography',
    'custodian_name',
    'parent_display_name',
    'child_display_name',
    'none',
];
